export default "__VITE_ASSET__Bix5HNDI__"